import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import ChatwootHint from '../ChatwootHint';
import {
 CircleMenuBlock,
 CircleButton,
 SocialList,
 SocialListItem,
 Viber,
 Telegram,
 Chat,
} from './CircleMenu.styled';
import Cookies from 'js-cookie';

declare const window: any;

const CircleMenu = () => {
 const [active, setActive] = useState(false);
 const [opened, setOpened] = useState(false);
 const [chatwootHint, setChatwootHint] = useState(false);

 const location = useLocation();

 const isMainPage = location.pathname === '/';
 const isMobile = localStorage.mobile || window.navigator.maxTouchPoints > 1;

 const addClass = () => {
  setActive(!active);
  setOpened(!opened);
  setChatwootHint(false);
  if (active) window.$chatwoot?.toggle('close');
 };

 const openChat = () => {
  window.$chatwoot?.toggle();
 };

 useEffect(() => {
  if (!isMainPage) {
   setActive(true);
   setOpened(true);

   return;
  }

  const firstOpen = Cookies.get('firstOpenChat');
  if (isMobile) {
   if (firstOpen !== 'firstOpen') {
    setChatwootHint(true);
    Cookies.set('firstOpenChat', 'firstOpen');
   } else {
    setChatwootHint(false);
   }
  } else if (firstOpen !== 'firstOpen') {
   window.addEventListener('chatwoot:ready', function () {
    const timeout = setTimeout(() => {
     setActive(true);
     setOpened(true);
     window.$chatwoot?.toggle('open');
    }, 3000);
    Cookies.set('firstOpenChat', 'firstOpen');
    return () => clearTimeout(timeout);
   });
  } else {
   return;
  }
 }, [isMainPage, isMobile]);

 return (
  <>
   <ChatwootHint opened={chatwootHint} setOpened={setChatwootHint} />
   <CircleMenuBlock>
    <CircleButton
     active={active}
     onClick={addClass}
     type="button"
     id="widg"
    ></CircleButton>
    <SocialList>
     {/* <SocialListItem
            className="circle-menu__item telegram"
            opened={opened}
          >
            <Viber
              opened={opened}
              href="viber://pa?chatURI=vostokchatsbot "
              title="viber"
            ></Viber>
          </SocialListItem> */}
     <SocialListItem className="circle-menu__item vkontakte" opened={opened}>
      <Telegram
       opened={opened}
       href="https://t.me/VostokChat_bot"
       title="telegram"
      ></Telegram>
     </SocialListItem>
     <SocialListItem onClick={openChat} opened={opened} title="chat">
      <Chat opened={opened}></Chat>
     </SocialListItem>
    </SocialList>
   </CircleMenuBlock>
  </>
 );
};

export default CircleMenu;
